import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Button from "../../components/atoms/Button";
import { GetDocs, SignAgreementNoDigisign } from "../../redux/actions/LoanAgreement";
import { GetDigisignPage } from "../../redux/actions/LoanDetail";
import RefreshToken from "../../redux/actions/RefreshToken";
import { REQ_DETAIL_LOAN, REQ_DETAIL_LOAN_DONE } from "../../utils/constants/actionTypes";
import ModalTTD from "./ModalTTD";

class ButtonTTD extends Component {
	constructor(props) {
		super(props);

		this.state = {
			success: false,
			loadingModal: false,
			showModalSign: false,
			accDisclaimer: false,
		};
	}

	generateDoc = () => {
		const { RefreshToken, GetDocs, loanDetail, profileState, SetLoadingPage, SetLoadingPageDone } = this.props;
		const { loanCode, isDigitalSignature } = loanDetail.detail;
		const { picUID } = profileState.picDetail;

		SetLoadingPage();
		RefreshToken((ClientID) => {
			this.setState({ loadingModal: false });
			GetDocs(ClientID, loanCode, (dataSuccess) => {
				if (dataSuccess) {
					if (isDigitalSignature) {
						GetDigisignPage(ClientID, dataSuccess, picUID, (status, payload) => {
							console.log(status, payload);
							//window.open(payload, "Popup", "toolbar=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30");
							window.open(payload, "popUpWindow", "height=700, width=680, left=50, top=50, resizable=yes, scrollbars=yes, toolbar=no, menubar=no, location=no, directories=no, status=yes");
							SetLoadingPageDone();
						});
					} else {
						this.setState({ showModalSign: true });
						SetLoadingPageDone();
					}
				} else {
					SetLoadingPageDone();
				}
			});
		});
	};

	signAgreementNoDigisign = () => {
		const { RefreshToken, SignAgreementNoDigisign, loanDetail } = this.props;
		const { loanCode } = loanDetail.detail;

		this.setState({ loadingModal: true, success: false });
		RefreshToken((ClientID) => {
			if (ClientID) {
				SignAgreementNoDigisign(ClientID, loanCode, (status) => {
					if (status) {
						this.setState({ loadingModal: false, success: true });
					} else {
						this.setState({ loadingModal: false, success: false });
					}
				});
			}
		});
	};

	changeDisclaimer = () => {
		let disclaimer = this.state.accDisclaimer;
		this.setState({ accDisclaimer: !disclaimer });
	};

	render() {
		let { success, showModalSign, accDisclaimer, loadingModal } = this.state;
		let { loanAgreementState, profileState, loanDetail } = this.props;
		const isDisabledCondition = loanDetail.detail.digisignCheck && profileState && loanDetail.detail.digisignCheck.signRecipient[0].userUID === profileState.picDetail.picUID && loanDetail.detail.digisignCheck.signRecipient[0].isSigned;

		return (
			<Fragment>
				<div className="container-btn-ttd">
					<Button title="Tanda Tangan" type="button" onClick={this.generateDoc} color="blue" isDisabled={isDisabledCondition} width="big" className="padding-btn" />
				</div>
				{showModalSign && (
					<ModalTTD
						contentDoc={loanAgreementState}
						loadingModal={loadingModal}
						onClose={() => this.setState({ showModalSign: false })}
						closeSuccess={() => this.props.history.push("/pinjaman-aktif")}
						changeDisclaimer={this.changeDisclaimer}
						accDisclaimer={accDisclaimer}
						onClick={this.signAgreementNoDigisign}
						contentSuccess={`Proses penandatanganan telah berhasil, harap menunggu konfirmasi selanjutnya`}
						titleSuccess={"Proses Penandatanganan Berhasil"}
						success={success}
					/>
				)}
			</Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		loanDetail: state.loanDetailState,
		profileState: state.profileState.list,
		loanAgreementState: state.loanAgreementState,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		GetDocs: (ClientID, loanCode, cb) => {
			dispatch(GetDocs(ClientID, loanCode, cb));
		},
		SignAgreementNoDigisign: (ClientID, loanCode, cb) => {
			dispatch(SignAgreementNoDigisign(ClientID, loanCode, cb));
		},
		SetLoadingPage: () => {
			dispatch({ type: REQ_DETAIL_LOAN });
		},
		SetLoadingPageDone: () => {
			dispatch({ type: REQ_DETAIL_LOAN_DONE });
		},
		RefreshToken: (cb, isPageLoading) => {
			dispatch(RefreshToken(cb, isPageLoading));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonTTD);
